import React, {useEffect, useState} from 'react';
import 'components/header/_header.scss';
import {routes} from "common";
import {Link, useLocation, useNavigate} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {authExtraActions} from "reduxStore/actions";
import {useGoogleLogin} from "@react-oauth/google";
import {authActions} from "reduxStore/reducers/authSlice";
import {generalActions} from "reduxStore/reducers/generalSlice";
import {IconGoogle} from "assets/icons";
import {toast} from "react-toastify";
import {Logo} from 'assets/images';
import ConfirmModal from 'components/modals/ConfirmModal';
import {HiMenuAlt2} from 'react-icons/hi';

function Header() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const {user, isUserLoggedIn} = useSelector(state => state.auth);
  const [showLogoutConfirm, setShowLogoutConfirm] = useState(false);

  const requestLogout = () => setShowLogoutConfirm(true);

  const handleConfirmLogout = () => {
    dispatch(authActions.logout());
    setShowLogoutConfirm(false);
    navigate(routes.LOGIN);
  };

  const handleCancelLogout = () => setShowLogoutConfirm(false);

  useEffect(() => {
    dispatch(generalActions.resetData())
  }, [location]);

  return (
    <header className="login-header">
      <div className="login-header-left">
        {isUserLoggedIn && (
          <button
            type="button"
            className="sidebar-toggle-btn"
            onClick={() => dispatch(generalActions.toggleSidebar())}
            aria-label="Toggle menu"
          >
            <HiMenuAlt2 />
          </button>
        )}
        <img src={Logo} alt="esseng logo" className="login-logo"/>
      </div>
      {isUserLoggedIn && (<button className="primary-btn" onClick={requestLogout}>
        Log Out
      </button>)}
      <ConfirmModal
        show={showLogoutConfirm}
        title="Confirm Logout"
        message="Are you sure you want to log out?"
        confirmText="Log Out"
        cancelText="Cancel"
        variant="danger"
        onConfirm={handleConfirmLogout}
        onCancel={handleCancelLogout}
      />
    </header>

  );
}

export default Header;
